import { LitElement, html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';

import '@amityeko/design-system/dist/providers/notification';

import '../../components/recognition-compact-preview';
import '../../components/view-recognition-message';
import '../../components/recognition-detail';

import type RnRViewRecognitionMessage from '../../components/view-recognition-message';
import type RnRRecognitionDetail from '../../components/recognition-detail';

@customElement('rnr-page-recognition-compact-preview')
export default class RnRPageRecognitionCompactPreview extends LitElement {
  @query('#view_recognition_message') recognitionMessage!: RnRViewRecognitionMessage;
  @query('#recognition_detail') recognitionDetail!: RnRRecognitionDetail;

  @property({ attribute: 'recognition-id' })
  recognitionId?: string;

  @property({ type: Boolean, attribute: 'should-use-pronoun' })
  shouldUsePronoun?: boolean;

  private _onSelectViewRecognitionPreview(e: CustomEvent) {
    this.recognitionMessage.show(e?.detail);
  }

  private _onSelectViewDetail(e: CustomEvent) {
    if (!e.detail.recognitionId) return;
    this.recognitionDetail.show(e.detail.recognitionId);
  }

  private _onRecognitionDetailClose() {
    this.recognitionMessage.show();
  }

  protected render() {
    return html`
      <amityeko-notification-provider>
        <rnr-recognition-compact-preview
          .recognitionId=${this.recognitionId}
          ?shouldUsePronoun=${this.shouldUsePronoun}
          @rnr-select-view-recognition=${this._onSelectViewRecognitionPreview}
        ></rnr-recognition-compact-preview>

        <rnr-view-recognition-message
          id="view_recognition_message"
          @rnr-on-view-detail-hide=${this._onSelectViewDetail}
        ></rnr-view-recognition-message>

        <rnr-recognition-detail
          id="recognition_detail"
          @rnr-select-recognition-detail-close=${this._onRecognitionDetailClose}
        ></rnr-recognition-detail>
      </amityeko-notification-provider>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-page-recognition-compact-preview': RnRPageRecognitionCompactPreview;
  }
}
